// extracted by mini-css-extract-plugin
export default {"container":"Warehouse_container__05dA0","header":"Warehouse_header__a-ynt","mobileSearch":"Warehouse_mobileSearch__toMDB"};